import { trackingDocumentListAppSearch } from 'services/analytics';

export const trackingIntegrationFeed = (appName: any, totalItems: any) => {
  return trackingDocumentListAppSearch(appName || '', totalItems || 0);
};
